@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.cost-review-header {
  display: flex;
  background-color: @cost-review-item--header--background-color;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.provider-logo {
  height: 100%;
  padding: 5px;
  width: 40px;
  min-width: 40px;

  > img {
    height: 100%;
    width: 100%;
  }
}

.provider-details {
  display: flex;
  flex-direction: column;
}

.provider-name {
  font-size: 16px;
  line-height: 16px;
  margin-top: 4px;
}

.provider-balance {
  line-height: 18px;
  font-size: 13px;
}

.provider-balance-amount {
  color: @cost-review-item--header-balance--text-color;
  padding-left: 5px;
  font-weight: @bold;
}
